import DataTable from '../admin-panel/classes/global/DataTable';

DataTable.prototype.config = function(property, row, data, dataIndex) {
   return {
        scrollCollapse: true,
        mark: {
            filter: function(node){
                var datatable = $(node.parentElement).closest('.dataTables_wrapper')
                var datatableFilter = $('.datatable__filters th', datatable)
                    .eq($(node).closest("td").index())
                    .find('.datatable__filter');

                if(
                    datatableFilter.hasClass('datatable__filter--select') ||
                    datatableFilter.hasClass('datatable__filter--select-multi') ||
                    datatableFilter.hasClass('datatable__filter--select-multi-ajax')
                ){
                    return false;
                }
                return true;
            }
        },
        scrollX: true,
        language: {
            url: '/js/admin-panel/vendor/dataTables/lang/' + $("html").attr("lang") + '.json'
        },
        drawCallback: function( settings ) {
            $('.dt-button','.dataTables_wrapper').removeClass("dt-button");
        },
        ajax: {
            error: function (jqxhr, textStatus, thrownError) {
                if(thrownError == 'Unauthorized' || jqxhr.status == 401 || jqxhr.status == 419) {
                    window.location.replace(routeLogin);
                }
            }
        },
    }
}


// WEBPACK FOOTER //
// ./resources/js/app/_global.js